import { Spinner } from "../../../components/Spinner";
import {
  useAccionEquipoMutation,
  useLazyEquipoQuery,
} from "../../../services/docs";
import { useForm } from "../../../hooks/useForm";
import { useNavigate } from "react-router-dom";
import { Label } from "../../../components/ui/Label";
import { Input } from "../../../components/ui/Input";
import Button from "../../../components/ui/Button";
import { toastr } from "react-redux-toastr";
import { EquipoComponent } from "../../../components/EquipoComponet";
import { useEffect } from "react";

export const EquipoScreen = () => {
  const [getEquipo, { data, isLoading }] = useLazyEquipoQuery();

  const { formulario, handleInputChange, handleSelectChange } = useForm({
    user_id: "",
    accion: "",
  });
  const [generarAction, { data: reporte, error, isLoading: accionLoading }] =
    useAccionEquipoMutation();
  useEffect(() => {
    getEquipo();
  }, []);
  const generar_accion = async (user_id: number, accion: string) => {
    const resp = await generarAction({
      accion: accion,
      user_id: +user_id,
    }).unwrap();
    if (resp) {
      toastr.success(resp.message);
      getEquipo();
    }
  };
  if (isLoading) {
    return (
      <div className="flex w-full justify-center">
        <Spinner />
      </div>
    );
  }
  return (
    <>
      <div className="card rounded-2xl">
        <div className="w-full text-left">
          <h1 className="text-1xl  font-bold">Equipo</h1>
        </div>
      </div>
      <div className="mt-10 grid grid-cols-4 place-items-stretch gap-4">
        {isLoading && (
          <div className="flex w-full justify-center">
            <Spinner />
          </div>
        )}
        {!isLoading && data && data.equipo && data.equipo.length === 0 && (
          <div className="my-4 rounded bg-primary py-2 text-center text-white">
            No se encontraron datos
          </div>
        )}
        {!isLoading && data && data.equipo && data.equipo.length > 0 && (
          <EquipoComponent
            data={data.equipo}
            accion={generar_accion}
            loadingAccion={accionLoading}
          />
        )}
      </div>
    </>
  );
};
